import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AppMobileNavigator',
  setup(__props) {


const { queryModel, navigatorItems, queryAlgolia, execute } = useNavigator()


return (_ctx: any,_cache: any) => {
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, {
    "base-color": "white",
    style: {"color":"white"},
    modelValue: _unref(queryModel),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(queryModel) ? (queryModel).value = $event : null)),
      _unref(execute)
    ],
    items: _unref(navigatorItems),
    placeholder: "Find a page...",
    "item-title": "name",
    "item-value": "route",
    variant: "underlined",
    "menu-props": { offset: 10 },
    color: "#295fd2",
    "menu-icon": "",
    "auto-select-first": "",
    "return-object": "",
    "onUpdate:search": _unref(queryAlgolia),
    class: "hy-search"
  }, {
    item: _withCtx(({ props, item }) => [
      _createVNode(_component_v_list_item, _mergeProps(props, {
        subtitle: item.raw['type'],
        title: item.raw['name']
      }), {
        prepend: _withCtx(() => [
          (item.raw['icon'])
            ? (_openBlock(), _createBlock(_component_hy_icon, {
                key: 0,
                name: item.raw['icon']
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          (item.raw['image'])
            ? (_openBlock(), _createBlock(_component_v_avatar, {
                key: 1,
                image: item.raw['image']
              }, null, 8, ["image"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1040, ["subtitle", "title"])
    ]),
    append: _withCtx(() => [
      _createVNode(_component_hy_icon, {
        name: "Map",
        color: "white",
        small: _ctx.$ui.mobile
      }, null, 8, ["small"])
    ]),
    _: 1
  }, 8, ["modelValue", "items", "onUpdate:search", "onUpdate:modelValue"]))
}
}

})